/* @flow */

import * as React from 'react';
import './header.module.css';

type Props = {
    children?: React.Node,
    as: string,
};

Header.defaultProps = {
    as: 'div',
};

export function Header({children, as: Tag}: Props) {
    return <Tag styleName='header'>{children}</Tag>;
}
